module.exports = __webpack_public_path__ + "img/kehu_xindazheng.93f6bbcf.png";